
const getListOfFieldToTouch = (errors: Record<string, any> | any[]): any => {
  if (Array.isArray(errors)) {
    return errors.map(item => getListOfFieldToTouch(item));
  } else if (errors !== null && typeof errors === 'object') {
    return Object.keys(errors).reduce((acc, key) => {
      (acc as Record<string, any>)[key] = getListOfFieldToTouch(errors[key]);

      return acc;
    }, {});
  }

  // For non-object, non-array types (like strings, numbers, etc.),
  // simply return true to mark it as touched.
  return true;
};

export default getListOfFieldToTouch;
